export enum QrcodeType {
  SumbitCashInformation, //提交兑奖信息表单
  CashPrize, // 开始兑奖
  ActivityRecharge, // 活动期间
}

export const QrcodeText = {
  [QrcodeType.ActivityRecharge]: ["topup_lottery_rayvision"],
  [QrcodeType.CashPrize]: [
    "topup_lottery_rayvision",
    "topup_lottery_contact_assistant",
  ],
  [QrcodeType.SumbitCashInformation]: [
    "topup_lottery_rayvision",
    "topup_lottery_add_assistant_tip",
  ],
};

export enum TicketType {
  NoCash, //未兑奖
  NoWinPrize, //未中奖，
  WinPrize, //中奖
}

export enum TicketReceivingInfoType {
  Recharge, //活动期间
  NoFillin, //未填写兑奖信息
  Edit, // 已填写，
  Expired, //过期未填写
  Cash, // 已兑奖
}

export enum ModalPage {
  PrizeCouponPage, // 奖券
  CashInformationPage, // 兑奖
  CashInformationSuccess, // 兑奖信息提交成功
}

export const PrizeList = {
  [TicketType.NoCash]: { fillColor: "", prizeColor: "", prizeBgColor: "" },
  [TicketType.NoWinPrize]: {
    fillColor: "#EAAD52",
    prizeColor: "#D77A0D",
    prizeBgColor: "#F2CB90",
  },
  [TicketType.WinPrize]: {
    fillColor: "#FD5C42",
    prizeColor: "#AA2111",
    prizeBgColor: "#FE9887",
  },
};

export const CashPrizeText = {
  [TicketReceivingInfoType.Recharge]: {
    content: "topup_lottery_get_lottery",
    subTitle: "",
    status: "",
    fields: "",
    isDate: false,
  },
  [TicketReceivingInfoType.NoFillin]: {
    content: "topup_lottery_fill_information",
    subTitle: "topup_lottery_valid_until",
    status: "",
    fields: "endTime",
    isDate: true,
  },
  [TicketReceivingInfoType.Edit]: {
    content: "topup_lottery_edit_information",
    subTitle: "topup_lottery_valid_until",
    status: "topup_lottery_information_submitted",
    fields: "endTime",
    isDate: true,
  },
  [TicketReceivingInfoType.Expired]: {
    content: "",
    subTitle: "topup_lottery_redemption",
    status: "topup_lottery_expired",
    fields: "",
    isDate: false,
  },
  [TicketReceivingInfoType.Cash]: {
    content: "",
    subTitle: "topup_lottery_logistics_information",
    status: "topup_lottery_redeemed",
    fields: "remark",
    isDate: false,
  },
};
interface PrizeProps {
  [key: number]: {
    cnName: string;
    enName: string;
  };
}

export const PrizeLevelContent: PrizeProps = Object.freeze({
  1: { cnName: "一等奖", enName: "First prize" },
  2: { cnName: "二等奖", enName: "Second prize" },
  3: { cnName: "三等奖", enName: "Third prize" },
  4: { cnName: "四等奖", enName: "Four prize" },
  5: { cnName: "五等奖", enName: "Fifth prize" },
  6: { cnName: "六等奖", enName: "Sixth prize" },
  7: { cnName: "七等奖", enName: "Seventh prize" },
});
